const stickyHeaderCellSx = {
  position: "sticky",
  top: 0,
  zIndex: 3,
  backgroundColor: "background.paper",
  fontSize: "13px",
  color: "#1976d2",
};

const stickySubHeaderCellSx = {
  position: "sticky",
  top: 56,
  zIndex: 2,
  backgroundColor: "background.paper",
  fontSize: "13px",
  color: "#1976d2",
};

export { stickyHeaderCellSx, stickySubHeaderCellSx };